export default __webpack_public_path__ + "f2814f89ed4abdab2b68d2c93f3b69bc.png";